export default __webpack_public_path__ + "static/media/three-two-one.f3fc7b66.png";